import {
  NAV_SHOW_TAB,
  NAV_HIDE_TAB,
  NAV_SET_ROUTE,
  NAV_SEE_ACTION_AGAIN,
  NAV_CHANGE_APP_STATE,
  NAV_CHANGE_FIELD,
} from "./constants";
import moment from "moment";
import Colors from "../../constants/Colors";
import { INavReducer } from "./types";

const INITIAL_STATE: INavReducer = {
  safeAreaTopColor: Colors.blue,
  safeAreaBottomColor: Colors.blue,
  isTopSafeAreaHidden: false,
  topTabSelected: 0,
  scrollTop: false,
  isTabVisible: true,
  seeActionAgain: false,
  appReady: true,
  route: "Foo",
  prevRoute: "Foo",
  appState: "active",
  codePushStatus: "",
  hasNotificationsEnabled: true,
  hasNotificationsEnabledCheckDate: moment().subtract(2, "day").toDate(),
};

export default (state: INavReducer = INITIAL_STATE, action): INavReducer => {
  switch (action.type) {
    case NAV_HIDE_TAB: {
      return {
        ...state,
        isTabVisible: false,
      };
    }

    case NAV_SHOW_TAB: {
      return {
        ...state,
        isTabVisible: true,
      };
    }

    case NAV_SET_ROUTE: {
      return {
        ...state,
        route: action.payload,
        prevRoute: state.route,
      };
    }

    case NAV_SEE_ACTION_AGAIN: {
      return {
        ...state,
        seeActionAgain: action.payload,
      };
    }

    case NAV_CHANGE_FIELD: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case NAV_CHANGE_APP_STATE: {
      return {
        ...state,
        appState: action.payload,
      };
    }

    default:
      return state;
  }
};
